// src/config.js

export const timeInterval = {
  WS_CONNECTION_WAIT_TIME: 5000, // 5 seconds
  WS_RECONNECT_DELAY: 1000, // 1 second
};

export const webSocket = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  SUBSCRIBE: "/topic/progress", // Replace with your actual subscription endpoint
};

// You can add more configuration variables as needed
